import { Button } from 'reactstrap';
import {
  useToast,
  useTranslator,
  useAppContext,
  cloudflareImage,
  mealPlaceholderImage,
} from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';
import { useOutletContext } from 'react-router-dom';

const FavMeal = ({ meal, removeMealFromFavorites, addMealToFavorites, toggleInsertDate }) => {
  const navigate = useNavigate();
  const { toastSuccess, toastError } = useToast();
  const { t } = useTranslator();
  const { trackFirebaseEvent } = useOutletContext();

  const {
    consts: { APP_BRAND },
    images: { favouriteFull, addToMealplan },
  } = useAppContext();

  const handleRemoveMeal = async () => {
    try {
      const response = await removeMealFromFavorites.removeMeal(meal.id);
      if (response.data.me.removeMealFromFavoritesByMealId.__typename === 'BasicMutationSuccess') {
        toastSuccess(
          <p>
            {t('mealPlan.favorites.notification.removedFromFav.content')}
            <Button color="link" onClick={() => handleAddMeal(meal.id)}>
              {t('meal.favorites.notification.removedFromFav.button')}
            </Button>
          </p>
        );

        trackFirebaseEvent('user_action', {
          action: 'tap-delete_favourites',
          location: 'V_favourites',
          meal_id: meal.id,
          meal_category: meal.name,
        });
      }
    } catch (error) {
      toastError();
      throw new Error(`Failed to remove meal from favorites: ${error}`);
    }
  };

  const handleAddMeal = async (mealId) => {
    try {
      await addMealToFavorites.addMeal(mealId);
    } catch (error) {
      toastError();
      throw new Error(`Failed to add meal to favorites: ${error}`);
    }
  };

  const renderMealImage = () => {
    let mealImg;
    if (meal.preparationImageUrl) {
      mealImg = meal.preparationImageUrl;
    } else {
      mealImg = mealPlaceholderImage(meal.mealType, APP_BRAND);
    }

    const coverImage = cloudflareImage(mealImg, `${APP_BRAND}`, 'cookbookMealItemVertical');

    return <img src={coverImage} className="img-fluid" alt="" />;
  };

  return (
    <div className="meal">
      <div className="meal-box cursor-pointer">
        <div
          className="meal-image"
          onClick={() => navigate(`/meals/day-plan/module/favourite-meals/${meal.id}`)}
        >
          {renderMealImage()}
        </div>

        <div
          className="tags"
          onClick={() => navigate(`/meals/day-plan/module/favourite-meals/${meal.id}`)}
        >
          {meal.mealCustomTag && meal.mealCustomTag.label && (
            <span
              className="tag me-1"
              style={{ backgroundColor: meal.mealCustomTag.color, color: '#fff' }}
            >
              {meal.mealCustomTag.label}
            </span>
          )}
          <span className="tag me-1">{meal.name}</span>
        </div>

        <div
          className="meal-title mb-s"
          onClick={() => navigate(`/meals/day-plan/module/favourite-meals/${meal.id}`)}
        >
          <p className="semi-bold mb-0">{meal.publicName}</p>
        </div>

        <Button
          color="link"
          size="sm"
          className="w-100 px-0 z-index-999"
          onClick={() => toggleInsertDate(meal.id)}
        >
          <img src={addToMealplan} alt="" className="me-2" />
          {t('mealThumb.addToMenuButton')}
        </Button>
      </div>
      <button className="add-remove-fav" type="button" onClick={handleRemoveMeal}>
        <img src={favouriteFull} alt="" width="32" height="32" />
      </button>
    </div>
  );
};

export default FavMeal;
